const shared = {
    title: 'Already Connected',
    addApi: 'api/exclusions/add',
    listApi: 'api/exclusions/list',
    removeApi: 'api/exclusions/remove',
    statsApi: 'api/exclusions/stats',
    membersApi: 'api/members/list',
};

export default shared;
